/* eslint-disable no-bitwise */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { TFunction } from 'i18next';

dayjs.extend(utc);

export function phoneFormatter(phone?: string) {
  const cleaned = (`${phone}`).replace(/\D/g, '');
  const match = cleaned.match(/^(998|)?(\d{2})(\d{3})(\d{2})(\d{2})$/);
  if (match) {
    const intlCode = (match[1] ? '+998 ' : '');
    return [intlCode, match[2], ' ', match[3], ' ', match[4], match[5]].join('');
  }
  return phone;
}

export function bankAccountFormatter(account: string | number) {
  // insert space between every 4 digits
  return account.toString().replace(/(\d{4})(?=(\d+))/g, '$& ');
}

export function cardPanFormatter(pan: string | number) {
  // insert space between every 4 digits
  return pan.toString().replace(/(\S{4})(?=(\S+))/g, '$& ');
}

export function mediaLinkFormatter(link: string) {
  return `/panel-main/file/download/${link}`;
}

export function textTruncate(text: string, length: number) {
  if (text.length > length) {
    return `${text.substring(0, length)}...`;
  }
  return text;
}

// export function numberFormatter(value?: number, fixed?: number, cutZeros?: boolean) {
//   if (!value) return 0;
//   const roundedValue = value.toFixed(2 || 0); // Округляем знаков после запятой
//   const [integerPart, decimalPart] = roundedValue.split('.'); // Разбиваем на целую и десятичную части

//   // Удаляем нулевые десятые и сотые, если они равны нулю
//   const decimalPartTrimmed = (parseInt(decimalPart, 10) === 0 && cutZeros) ? '' : `.${decimalPart}`;

//   // Возвращаем округленное число
//   return `${integerPart.replace(/(\d)(?=((\d{3})+)(\D|$))/g, '$& ')}${decimalPartTrimmed}`;
// }

export function numberFormatter(value?: number, fixed?: number) {
  if (!value) return 0;
  return value.toFixed(fixed || 0).toString().replace(/(\d)(?=((\d{3})+)(\D|$))/g, '$& ');
}

require('dayjs/locale/ru');

export function dateFormatter(date: number | Date | undefined | null | string /* ISO string only */, format: string) {
  return dayjs(date).locale('ru').format(format);
}

/**
 * Для дат, которые бэк отдаёт в UTC без указания зоны ("2026-09-16T10:00:00"):
 * dayjs() принял бы такую строку за локальное время, и дата отставала бы на смещение пояса
 */
export function utcDateFormatter(date: string | undefined | null, format: string) {
  return dayjs.utc(date).local().locale('ru').format(format);
}

// https://snipp.ru/jquery/word-declination-js
export function numbersDeclension(value: number, words: [string, string, string]) {
  const valueEnd = Math.abs(value) % 100;
  const num = valueEnd % 10;
  if (valueEnd > 10 && valueEnd < 20) return words[2];
  if (num > 1 && num < 5) return words[1];
  if (num === 1) return words[0];
  return words[2];
}

export const downloadSshKeyFile = (vmName: string, content: string, isPrivate: boolean) => () => {
  const link = document.createElement('a');
  link.download = `${vmName}_rsa${isPrivate ? '.ppk' : '.pub'}`;
  const blob = new Blob([content], { type: 'text/plain' });
  link.href = window.URL.createObjectURL(blob);
  link.click();
};

const OCTET = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)';
const IP = `${OCTET}(?:\\.${OCTET}){3}`;
const IP_LIST_RE = new RegExp(`^${IP}(?:\\s*,\\s*${IP})*$`);
const IP_RANGE_RE = new RegExp(`^${IP}\\s*-\\s*${IP}$`);
const ipToNumber = (ip: string): number => ip
  .split('.')
  .reduce((acc, octet) => acc * 256 + Number(octet), 0);
/**
 *
 * @param ipRange accept IP range and comma separated list
 */
export const checkIPRange = (ipRange?: string | null): boolean => {
  const value = ipRange?.trim();
  if (!value) return true;

  if (IP_LIST_RE.test(value)) return true;

  if (IP_RANGE_RE.test(value)) {
    const [start, end] = value.split('-').map((ip) => ip.trim());
    return ipToNumber(start) <= ipToNumber(end); // начало не больше конца
  }

  return false;
};

/**
 *
 * @param portRange accept IP range and comma separated list
 */
export const checkPortRange = (portRange?: string | null, maxPorts?: number): boolean => {
  if (!portRange) return true;
  const portArr = portRange.split(',');
  // split ranges
  if (portArr.length > (maxPorts || Infinity)) {
    return false;
  }

  const portAddressArr = portArr.reduce<string[]>((res, port) => {
    res.push(...port.split(':'));
    return res;
  }, [] as string[]);

  const portNumbersArr = portAddressArr.reduce<number[]>((res, port) => {
    const portNumber = Number(port);
    if (portNumber) {
      res.push(portNumber);
    }
    return res;
  }, []);

  for (let index = 0; index < portNumbersArr.length; index++) {
    const element = portNumbersArr[index];
    if (element > 65535) {
      return false;
    }
  }
  return true;
};

export function numberToIp(num: number) {
  return [
    (num >> 24) & 255,
    (num >> 16) & 255,
    (num >> 8) & 255,
    num & 255,
  ].join('.');
}

export const getMemorySizeLabelGb = (value: number | undefined | null, t: TFunction): [string, string] => {
  if (!value) return [`${0}`, t('file_size.gb')];
  if (value < 1024) {
    return [`${parseFloat((value).toFixed(2))}`, t('file_size.gb')];
  }
  return [`${parseFloat((value / 1024).toFixed(2))}`, t('file_size.tb')];
};

export const encodeObjectKey = (value: string): string => value
  .split('/')
  .map(encodeURIComponent)
  .join('/');
